import { Input, Form, Button, Divider, Card, Space, message, Spin, Select, Switch, DatePicker } from 'antd';
import APIUtils from '../../../api/APIUtils';
import WebLinks from '../../../api/WebLinks';
import { useContext, useEffect, useState } from 'react';
import { CommonContext } from '../../../Context';


const EmailNotification = () => {

  const formlayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const formlayoutCard = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  };

  //Variables declaration
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [buyerEmailNotificationForm] = Form.useForm();
  const [loader,setLoader]=useState(false);

  //On load function call
  useEffect(()=>{
    GetBuyerDetails();
  },[]);

  //Fuctions
  //Function to get buyer details{id}.
  const GetBuyerDetails = async () =>{
    setLoader(true);
    const response = await APIUtils.apiCall('GET',WebLinks.GetBuyerEmailNotificationSettings+buyerId);
    if(!response.isCatch && response.resultObj.statusCode==="2000"){
      //Setting field values for profile form.
      if(response.resultObj&&response.resultObj.data){
      buyerEmailNotificationForm.setFieldsValue({
        hiLiteLowCreditEmails:response?.resultObj?.data?.hiLiteLowCreditEmails===1?true:false,
        hiLiteNewJobEmails:response?.resultObj?.data?.hiLiteNewJobEmails===true?true:false,
        hiLitePromoEmails:response?.resultObj?.data?.hiLitePromoEmails===true?true:false,
      })
      setLoader(false);
    }else{
      message.error(response?.resultObj?.message);
      setLoader(false);
    }
        }
    };

  //Function to save edited profile data.
  const onEmailNotificationSave = async(values) => {
    setLoader(true);
    //Payload creation for edit profile save.
    let emailSavePayload=null;
    emailSavePayload={
      buyerId: buyerId,
      hiLiteLowCreditEmails: values?.hiLiteLowCreditEmails===true?1:0,
      hiLiteNewJobEmails: values?.hiLiteNewJobEmails,
      hiLitePromoEmails: values?.hiLitePromoEmails,
    };
    //save API call
    const saveEmailResponse = await APIUtils.apiCall('PUT',WebLinks.UpdateBuyerEmailNotificationSettings,JSON.stringify(emailSavePayload));
    if(!saveEmailResponse.isCatch && saveEmailResponse.resultObj.statusCode==="2000"){
      message.success(saveEmailResponse.resultObj.message);
    }else{
      message.error(saveEmailResponse.resultObj.message);
    }
    setLoader(false);
  };

  return (
    <div>
      <Spin spinning={loader}>
        <>
        <div className='uppercase font-bold text-xl'>Email Notifications</div>
        <Divider className='mt-2 mb-3' />
        <Form {...formlayout} className='lg:w-4/5' form={buyerEmailNotificationForm} onFinish={onEmailNotificationSave}>
            <Form.Item
              name="hiLiteLowCreditEmails"
              label="HI Lite Low Credit Emails"
              //valuePropName="checked"
            >
              <Switch defaultChecked checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            <Form.Item
              name="hiLiteNewJobEmails"
              label="HI Lite New Job Emails"
              //valuePropName="checked"
            >
              <Switch defaultChecked checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            <Form.Item
              name="hiLitePromoEmails"
              label="HI Lite Promo Emails"
              //valuePropName="checked"
            >
              <Switch defaultChecked checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
            <Form.Item
              className='mt-3'
              wrapperCol={{ span: 16, offset: 8 }}
              style={{ marginBottom: 0 }}
            >
              <Button type="primary" htmlType='submit'>Save</Button>
            </Form.Item>
        </Form>
        </>
      </Spin>
    </div>
  );
};

export default EmailNotification;